import type { NoticeDto } from '../../domain/contracts/api.contracts';
import { apiClient } from './apiClient';
import { noticeFromWire } from './wireAdapters';

/** E16 — GET /notices (role-filtered, non-expired) */
export async function getNotices(): Promise<NoticeDto[]> {
  const { data } = await apiClient.get<Record<string, unknown>[]>('/notices');
  return data.map(noticeFromWire);
}
